import { detailsQueries } from 'src/common/components/Sim/Details/queries/detailsQueries';

export const simDetailsQueries = {
  detail: (filter: { iccid: string }) => [...detailsQueries.details, 'SimProfile', filter],
  detailByImsi: (imsi: string) => [...detailsQueries.details, 'SimProfile', imsi],
};
